import React, { useCallback, useState, useEffect } from "react";
import { TextInput, PrimaryButton } from "../../components/UIkit";
import { useDispatch, useSelector } from "react-redux";
import { getUserId } from "../../reducks/users/selectors";
import { push } from "connected-react-router";
import { MovieArea } from "../../components/booths";
import { saveOpus } from "../../reducks/opuses/operations";
import { db } from "../../firebase/index";
import { MyPageDrawer } from "../../components/mypage";

const MovieEdit = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  // let id = window.location.pathname.split("/opus/edit")[1];
  // console.log("今のIDは" + id);

  const [name, setName] = useState(""),
    [id, setId] = useState(""),
    [description, setDescription] = useState(""),
    [size, setSize] = useState(""),
    [images, setImages] = useState([]),
    [price, setPrice] = useState("");

  if (id !== "") {
    let getID = id.split("/")[1];
    setId(getID);
    // console.log("IDがnullじゃなかったので" + id);
  }

  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );

  const inputDescription = useCallback(
    (event) => {
      setDescription(event.target.value);
    },
    [setDescription]
  );

  const inputSize = useCallback(
    (event) => {
      setSize(event.target.value);
    },
    [setSize]
  );

  const inputPrice = useCallback(
    (event) => {
      setPrice(event.target.value);
    },
    [setPrice]
  );

  useEffect(() => {
    let getid = window.location.pathname.split("/opus/edit")[1];
    setId(getid);
    if (id !== "") {
      // prettier-ignore
      db.collection('opusues').doc(id).get()
        .then((snapshot) => {
          const data = snapshot.data();
          setName(data.name);
          setDescription(data.description);
          setSize(data.size);
          setPrice(data.price);
          setImages(data.images);
        });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <section>
      <MyPageDrawer />
      <h2 className="form-text__headline text-center">動画投稿</h2>
      <div className={"common-section-container"}>
        <MovieArea images={images} setImages={setImages} />
        <TextInput
          fullWidth={true}
          label={"タイトル"}
          multiline={false}
          required={true}
          onChange={inputName}
          rows={1}
          value={name}
          type={"text"}
        />
        <TextInput
          fullWidth={true}
          label={"作品説明"}
          multiline={true}
          required={true}
          onChange={inputDescription}
          rows={5}
          value={description}
          type={"text"}
        />
        <TextInput
          fullWidth={true}
          label={"サイズ"}
          multiline={false}
          required={true}
          onChange={inputSize}
          rows={1}
          value={size}
          type={"text"}
        />
        <TextInput
          fullWidth={true}
          label={"価格"}
          multiline={false}
          required={true}
          onChange={inputPrice}
          rows={1}
          value={price}
          type={"number"}
        />
        <div className="spacer-box--l" />
        <div className="center">
          <PrimaryButton
            label={"作品を保存"}
            onClick={() =>
              dispatch(
                // prettier-ignore
                saveOpus(id, uid,images,name,description,size,price)
              )
            }
          />
        </div>
      </div>
      <div className="center">
        <button onClick={() => dispatch(push("/"))}>ホームへ</button>
      </div>
    </section>
  );
};

export default MovieEdit;
